import {clsx} from "clsx";
import {twMerge} from "tailwind-merge";
import {useTenantTheme} from "../../context/useSystemTenantStore";
import {contrastColor} from "contrast-color";


export default function Button({
   text,
   disabled,
   backgroundColor,
   textColor = "white",
   onClick,
   overrideThemeColors = false,
   className,
   }) {

    const theme = useTenantTheme();

    const resolveThemeColor = (color) => {
        switch (color) {
            case "primaryColor":
                return theme?.primaryHexColor;
            case "secondaryColor":
                return theme?.secondaryHexColor;
            case "tertiaryColor":
                return theme?.tertiaryHexColor;
            default:
                return color;
        }
    };

    function getBackgroundColor() {
        if (disabled) return undefined;
        if (!overrideThemeColors) return theme?.primaryHexColor;
        return resolveThemeColor(backgroundColor);
    }

    function getTextColor(resolvedBackgroundColor) {
        if (disabled) return undefined;
        if (textColor) return resolveThemeColor(textColor);
        if (!resolvedBackgroundColor) return "white";

        const contrast = contrastColor({bgColor: resolvedBackgroundColor});
        if (contrast === "black") return "black";
        return "white";
    }

    const resolvedBackgroundColor = getBackgroundColor();
    const resolvedTextColor = getTextColor(resolvedBackgroundColor);

    return (
        <button
            disabled={disabled}
            style={{
                backgroundColor: resolvedBackgroundColor,
                color: resolvedTextColor,
            }}
            className={twMerge(
                clsx(
                    "marker:inline-flex items-center min-w-24 h-[38px]",
                    "px-5 border border-transparent shadow-sm rounded-sm shadow-gray-300",
                    "justify-center text-md font-medium focus:outline-none w-full",
                    "font-semibold rounded-md",
                    disabled
                        ? "bg-gray-300 text-gray-700 cursor-not-allowed"
                        : "hover:opacity-70"
                ),
                className
            )}
            onClick={disabled ? () => {} : onClick}
        >
            <span className="whitespace-nowrap">{text}</span>
        </button>
    );
}